<template>
  <b-card :header="$t('project.eventsExport.eventsPage')">
    <div v-if="errored" class="alert alert-danger">{{errored}}</div>
    <div v-if="informed" class="alert alert-success">{{informed}}</div>
    <h4>{{ $t('project.eventsExport.mainText') }}</h4>
    <ol>
      <li>{{ $t('project.eventsExport.step1') }}</li>
      <li>{{ $t('project.eventsExport.step2') }}</li>
      <li>{{ $t('project.eventsExport.step3') }}</li>
      <li>{{ $t('project.eventsExport.step4') }}</li>
    </ol>
    <p>{{ $t('project.eventsExport.infoText') }}</p>

    <div role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-stations
            variant="info"
          >{{ $t('project.eventsExport.selectStations') }}</b-button>
        </b-card-header>
        <b-collapse
          id="accordion-stations"
          visible
          accordion="accordion"
          v-model="accStations"
          role="tabpanel"
        >
          <b-card-body>
            <b-form-group>
              <b-button size="sm" class="mb-2" @click="selectAllStations()" >{{ $t('project.alarmsExport.selectAll') }}</b-button>
              <b-form-checkbox-group id="stations" v-model="selectedStations" stacked>
                <b-form-checkbox v-for="(value, key) in stations" :key="key" :value="value.item1">{{ value.item2 }}</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
            <b-button
              class="mt-3"
              block
              variant="success"
              @click="selectStations()"
            >{{ $t('project.eventsExport.selectStationsConfirm') }}</b-button>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-events
            variant="info"
          >{{ $t('project.eventsExport.selectEvents') }}</b-button>
        </b-card-header>
        <b-collapse id="accordion-events" accordion="accordion" v-model="accEvents" role="tabpanel">
          <b-card-body>
            <b-row>
              <b-col md="6" class="my-1">
                <b-form-group label-cols-sm="3" :label="$t('other.filter')" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" :placeholder="$t('other.searchHolder')"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">{{ $t('other.clear') }}</b-button>
                      <b-button @click="toggleAllInFilter">{{ $t('project.alarmsExport.selectAll') }}</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6" class="my-1">
                <b-form-group label-cols-sm="3" :label="$t('other.perPage')" class="mb-0">
                  <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-table
              show-empty
              responsive
              small
              striped
              hover
              :items="events"
              :fields="eventsFields"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              @filtered="onFiltered"
            >
              <template #cell(HEAD_checkbox)="row" >
                <b-form-checkbox
                  @click.native.stop
                  v-model="allEventsSelected"
                  :indeterminate="allEventsInter"
                  @change="toggleAllEvent"
                ></b-form-checkbox>
              </template>

              <template #cell(checkbox)="row" >
                <b-form-checkbox
                  :id="'checkbox' + row.item.item1"
                  @click.native.stop
                  v-model="row.item.item4"
                  @change="toggleEvent(row.item)"
                />
              </template>

              <template
                #cell(module)="row"
              >{{ getModuleFromFullVariable(row.item.item5) }}</template>

              <template
                #cell(object)="row"
              >{{ getObjectFromFullVariable(row.item.item5) }}</template>
            </b-table>
            <b-row>
              <b-col md="6" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </b-row>
            <b-button
              class="mt-3"
              block
              variant="success"
              @click="selectEvents()"
            >{{ $t('project.eventsExport.selectEventsFinal') }}</b-button>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-export
            variant="info"
          >{{ $t('project.eventsExport.exportEvents') }}</b-button>
        </b-card-header>
        <b-collapse id="accordion-export" accordion="accordion" v-model="accExport" role="tabpanel">
          <b-card-body>
            <b-row>
              <b-col sm="6">
                <b-input-group :prepend="$t('project.graphViewer.customFrom')" class="mt-0">
                  <b-form-input type="date" v-model="dateFrom"></b-form-input>
                  <b-form-input type="time" v-model="timeFrom"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="6">
                <b-input-group :prepend="$t('project.graphViewer.customTo')" class="mt-0">
                  <b-form-input type="date" v-model="dateTo"></b-form-input>
                  <b-form-input type="time" v-model="timeTo"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row class="mt-2 mb-3">
              <b-col sm="2">
                <b-form-select v-model="exportDelimeter">
                  <option value=";">{{ $t('project.graphViewer.exportSemicolon') }}</option>
                  <option value=",">{{ $t('project.graphViewer.exportComma') }}</option>
                </b-form-select>
              </b-col>
              <b-col sm="5">
                <b-button
                  block
                  variant="success"
                  @click="generateCsv()"
                >{{ $t('project.eventsExport.generateEvents') }}</b-button>
              </b-col>
              <b-col sm="5">
                <b-button
                  block
                  variant="secondary"
                  @click="downloadCsv()"
                >{{ $t('project.eventsExport.downloadEvents') }}</b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" class="my-1">
                <b-form-group label-cols-sm="3" :label="$t('other.filter')" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="exportFilter" :placeholder="$t('other.searchHolder')"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!exportFilter" @click="exportFilter = ''">{{ $t('other.clear') }}</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6" class="my-1">
                <b-form-group label-cols-sm="3" :label="$t('other.perPage')" class="mb-0">
                  <b-form-select v-model="exportPerPage" :options="pageOptions"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-table
              show-empty
              responsive
              small
              striped
              hover
              :items="dataToExport"
              :fields="dataToExportFields"
              :current-page="exportCurrentPage"
              :per-page="exportPerPage"
              :filter="exportFilter"
              thead-class="d-none"
              @filtered="onExportFiltered"
            >
              <template #cell(date)="row" >
                {{ getFormatDateString(row.item.event.mark) }}
              </template>
              <template #cell(status)="row" >
                {{ getEventStatusString(row.item.event.value) }}
              </template>
            </b-table>
            <b-row>
              <b-col md="6" class="my-1">
                <b-pagination
                  v-model="exportCurrentPage"
                  :total-rows="exportTotalRows"
                  :per-page="exportPerPage"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
    <project-back-button />
  </b-card>
</template>

<script>
import { exportService } from "@/_services";
import { errorHandler, csvExport, formatNumber } from "@/_helpers";
import { router } from "@/router";
import ProjectBackButton from "@/components/projects/ProjectBackButton";

export default {
  name: "ProjectEvents",
  components: {
    projectBackButton: ProjectBackButton
  },
  data() {
    return {
      projectId: null,
      stations: [],
      errored: null,
      informed: null,
      selectedStations: [],
      events: [],
      selectedEvents: [],
      allEventsSelected: false,
      allEventsInter: false,
      filteredEvents: [],
      accStations: true,
      accEvents: false,
      accExport: false,
      eventsFields: [
        { key: "checkbox", label: "" },
        { key: "module", label: "" },
        { key: "object", label: "" },
        { key: "item3", label: "" },
        { key: "item2", label: "" }
      ],
      dataToExportFields: [
        { key: "date", label: "" },
        { key: "module", label: "" },
        { key: "object", label: "" },
        { key: "description", label: "" },
        { key: "status", label: "" }
      ],
      currentPage: 1,
      filter: null,
      totalRows: null,
      perPage: 25,
      pageOptions: [25, 50, 75, 100],
      exportCurrentPage: 1,
      exportFilter: null,
      exportTotalRows: null,
      exportPerPage: 25,
      dataToExport: [],
      fileName: "",
      csvContent: "",
      dateFrom: null,
      timeFrom: null,
      dateTo: null,
      timeTo: null,
      exportDelimeter: ";"
    };
  },
  watch: {
    selectedEvents() {
      this.syncPickerSelectAllState();
    }
  },
  created() {
    this.projectId = parseInt(this.$route.params.projectId, 10);
    if (isNaN(this.projectId) || this.projectId < 0) {
      router.push("/error404");
      return;
    }

    var now = new Date();
    now.setHours(now.getHours() + 1);
    this.dateTo =
      formatNumber(now.getFullYear(), 2, "0") +
      "-" +
      formatNumber(now.getMonth() + 1, 2, "0") +
      "-" +
      formatNumber(now.getDate(), 2, "0");
    this.timeTo = formatNumber(now.getHours(), 2, "0") + ":00:00";
    now.setHours(now.getHours() - 8);
    this.dateFrom =
      formatNumber(now.getFullYear(), 2, "0") +
      "-" +
      formatNumber(now.getMonth() + 1, 2, "0") +
      "-" +
      formatNumber(now.getDate(), 2, "0");
    this.timeFrom = formatNumber(now.getHours(), 2, "0") + ":00:00";

    exportService
      .getStationsForProjects(this.projectId)
      .then(response => {
        this.stations = response.data;
      })
      .catch(error => {
        this.errored = errorHandler(error);
      });
  },
  methods: {
    onFiltered(filteredItems) {
      this.filteredEvents = filteredItems;
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      this.syncPickerSelectAllState();
    },
    syncPickerSelectAllState() {
      const items = this.filteredEvents || [];
      let selectedCount = 0;
      for (let i = 0; i < items.length; i++) {
        if (items[i].item4) selectedCount++;
      }
      if (items.length === 0 || selectedCount === 0) {
        this.allEventsInter = false;
        this.allEventsSelected = false;
      } else if (selectedCount === items.length) {
        this.allEventsInter = false;
        this.allEventsSelected = true;
      } else {
        this.allEventsInter = true;
        this.allEventsSelected = false;
      }
    },
    toggleAllEvent(checked) {
      const items = this.filteredEvents || [];
      for (let index = 0; index < items.length; index++) {
        items[index].item4 = !!checked;
        const selectedIndex = this.selectedEvents.indexOf(items[index].item1);
        if (checked) {
          if (selectedIndex === -1) {
            this.selectedEvents.push(items[index].item1);
          }
        } else if (selectedIndex !== -1) {
          this.selectedEvents.splice(selectedIndex, 1);
        }
      }
    },
    onExportFiltered(filteredItems) {
      this.exportTotalRows = filteredItems.length;
      this.exportCurrentPage = 1;
    },
    toggleAllInFilter() {
      this.toggleAllEvent(!this.allEventsSelected);
    },
    toggleEvent(event) {
      let index = this.selectedEvents.indexOf(event.item1);
      if (index != -1) {
        event.item4 = false;
        this.selectedEvents.splice(index, 1);
      } else {
        event.item4 = true;
        this.selectedEvents.push(event.item1);
      }
    },
    selectStations() {
      this.errored = null;
      this.informed = null;
      if (this.selectedStations.length === 0) return;
      this.selectedEvents = [];
      let jsonData = JSON.stringify({ stations: this.selectedStations });
      exportService
        .getEventsFromStations(this.projectId, jsonData)
        .then(response => {
          this.events = response.data;
          this.filteredEvents = response.data;
          this.filter = null;
          this.currentPage = 1;
          this.accStations = false;
          this.accEvents = true;
        })
        .catch(error => {
          this.errored = errorHandler(error);
        })
        .finally(() => {
          this.totalRows = this.events.length;
        });
    },
    selectAllStations() {
      if (this.stations.length == this.selectedStations.length) {
        this.selectedStations = [];
        return;
      }
      this.selectedStations = [];
      for (let i = 0; i < this.stations.length; i++) {
        this.selectedStations.push(this.stations[i].item1);
      }
    },
    selectEvents() {
      this.errored = null;
      this.informed = null;
      if (this.selectedEvents.length === 0) return;
      this.accEvents = false;
      this.accExport = true;
    },
    downloadCsv() {
      if (!this.csvContent) {
        this.informed = this.$i18n.t("project.eventsExport.noEventsGenerated");
        return;
      }
      csvExport(this.csvContent, this.fileName);
      this.informed = this.$i18n.t("project.eventsExport.eventsExported");
    },
    getFormatDateString(value) {
      return new Date(value + "Z").toUTCString();
    },
    getEventStatusString(value) {
      return value;
    },
    getObjectFromFullVariable(variable) {
      return variable.split(".")[1];
    },
    getModuleFromFullVariable(variable) {
      return variable.split(".")[0];
    },
    generateCsv() {
      this.errored = null;
      this.informed = null;
      if (
        !this.dateFrom ||
        !this.timeFrom ||
        !this.dateTo ||
        !this.timeTo ||
        this.selectedEvents.length === 0
      )
        return;
      if (
        this.dateFrom > this.dateTo ||
        (this.dateFrom == this.dateTo && this.timeFrom >= this.timeTo)
      )
        return;
      const from = this.dateFrom + "T" + this.timeFrom;
      const to = this.dateTo + "T" + this.timeTo;
      let jsonData = JSON.stringify({ codes: this.selectedEvents, from, to });
      exportService
        .getEventsExportData(this.projectId, jsonData)
        .then(response => {
          this.dataToExport = response.data;
          this.exportTotalRows = this.dataToExport.length;
          this.exportCurrentPage = 1;
          this.exportFilter = null;
          this.csvContent = "";
          if (response.data.length === 0)
            this.informed = this.$i18n.t(
              "project.eventsExport.noEventsGenerated"
            );
          else {
            for (let i = 0; i < response.data.length; i++) {
              const value = response.data[i];
              const date = this.getFormatDateString(value.event.mark);
              const status = this.getEventStatusString(value.event.value);
              this.csvContent +=
                date.replace(/[,;]/gi, "") +
                this.exportDelimeter +
                value.object.replace(/[,;]/gi, "") +
                this.exportDelimeter +
                value.description.replace(/[,;]/gi, "") +
                this.exportDelimeter +
                status +
                "\n";
            }
            this.fileName = "events_" + from + "_" + to + ".csv";
          }
        })
        .catch(error => {
          this.errored = errorHandler(error);
        });
    }
  }
};
</script>
